<template>
  <div class="withdrawal-funds">
    <v-notification>
    </v-notification>
    <Modal
        :style="showModalAdd ? 'display: block' : 'display: none'"
        :show="showModalAdd"
        modal-class="withdrawal-funds-modal"
        @close="toggleShowModalAdd"
    >
      <template #body>
        <div class="modal-content">
        <div class="modal-title">{{ getLocalization('Request a withdraw') }}</div>
        <div class="withdrawal-funds-modal__available">
          <div>{{ getLocalization('Available') }}</div>
          <span v-for="(currency, index) in availableBalances" :key="index">
            {{ currency }}
            <span v-if="index < availableBalances.length - 1"> / </span>
          </span>
        </div>
        <div class="withdrawal-funds-modal__form">
<!--          <div>-->
<!--            <div class="&#45;&#45;label">{{ getLocalization('Details / wallet') }}</div>-->
<!--            <div class="filter-button-group">-->
<!--              <div v-for="currency in availableCurrency" :key="currency.id"-->
<!--                   @click="formData.currency_id = currency.id"-->
<!--                   :class="currency.id === formData.currency_id ? 'active' : ''">-->
<!--                {{currency.name}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div>
            <div class="--label">{{getLocalization('Amount to currency')}}</div>
            <div class="--amount">
              <input type="text"
                  class="input"
                  :placeholder="getLocalization('Amount to currency')"
                  v-model="formData.sum"
              />
              <button class="button primary" @click="setAllBalance()">
                {{getLocalization('All available')}}
              </button>
            </div>
          </div>

          <div>
            <div class="--label">{{getLocalization('Method')}}</div>
            <div class="filter-button-group flex-wrap">
              <div v-for="method in availableWithdrawalMethods"
                   v-model="formData.type_of_withdrawal"
                   :class="formData.type_of_withdrawal_id === method.id ? 'active' : ''"
                   @click="setTypeOfWithdraw(method)">
                {{ method.title }}
              </div>
            </div>
            <div class="--help">
              {{ formData.type_of_withdrawal.title }} ({{commissionText}} {{getLocalization('fee')}})
            </div>
            <div v-if="usdtTypes.includes(formData.type_of_withdrawal_id)" class="--rate">
              {{ getLocalization('Exchange rate') }}: 1 {{ usdcTypes.includes(formData.type_of_withdrawal_id) ? 'USDC' : 'USDT' }} = {{usdRate}} RUB
            </div>
          </div>
          <div class="--warn" v-if="showExtraFieldsForCard">
            {{getLocalization('Please note that payments to Russian bank cards are made by exchanging USDT to RUB through one of the exchange services on the BestChange platform. Please take this into account when submitting your request. We recommend using temporary or virtual cards to receive funds.')}}
          </div>

          <div>
            <div class="--label">{{getLocalization('Bank card number / Wallet address')}}</div>
            <input
                type="text"
                class="input"
                v-model="formData.requisites"
                :placeholder="getLocalization('Bank card number / Wallet address')"
            />

            <input
                v-if="showExtraFieldsForCard"
                type="text"
                class="input"
                v-model="formData.full_name"
                :placeholder="getLocalization('Full name')"
            />
            <input
                v-if="showExtraFieldsForCard"
                type="text"
                class="input"
                v-model="formData.phone_number"
                :placeholder="getLocalization('Phone number (for SBP)')"
            />
            <div v-if="usdtTypes.includes(formData.type_of_withdrawal_id)" class="--warn">
              {{getLocalization('When creating a request, carefully check the entered payment details and select the correct network for the cryptocurrency transfer. In case of an error, funds may be lost without the possibility of recovery. The administration of https://SMSBOWER.ORG  is not responsible for any losses caused by incorrect data.')}}
            </div>
            <div v-else class="--warn">
              {{getLocalization('IMPORTANT: Make sure the payment details entered are correct when creating the withdrawal request above⬆️. The administration of SMSBower.com is not responsible in case of loss of funds due to incorrect payment details.')}}
            </div>
          </div>

          <div>
            <div class="--label">{{getLocalization('Comment')}}</div>
            <input
                type="text"
                autocomplete="off"
                class="input"
                v-model="formData.comment"
                :placeholder="getLocalization('Not necessary')"
            />
          </div>

        </div>
        <div class="withdrawal-funds-modal__submit">
          <button
              class="button orange"
              @click="showPasswordModal"
          >
            <img src="/img/svg/common/wallet.svg"/>
            {{getLocalization('Order a payout')}}
          </button>
        </div>
        </div>
      </template>
    </Modal>
    <Modal
        :style="this.passwordModal ? 'display: block' : 'display: none'"
        :show="this.passwordModal"
        modal-class="custom-modal-notification profile-modal"
        @close="togglePasswordModal"
    >
      <template #body>
        <div class="modal-content">
          <div class="profile-modal">{{getLocalization('Enter the password to confirm the withdrawal request')}}</div>
            <div class="auth__form">
              <div class="auth-form-element">
                <div class="auth-form-element__head mt-4">
                  <div class="auth-form-element__label">{{getLocalization('Confirm the withdrawal request with your password')}}*</div>
                </div>
                <label class="auth-form-element__input input-password">
                  <input class="d-none" name="autocomplete">
                  <input autocomplete="off" v-model="formData.password"
                         :placeholder="getLocalization('Your password')"
                         type="password">
                  <div class="--button">
                    <img src="/img/svg/common/glass-off.svg"></div>
                </label>
                <div class="auth-form-element__help"></div>
              </div> <!---->
            </div>
            <div class="auth__button">
              <button
                  class="button orange"
                  @click="submitForm"
              >
                <img src="/img/svg/common/wallet.svg"/>
                {{getLocalization('Order a payout')}}
              </button>
            </div>
        </div>
      </template>
    </Modal>
    <Modal
        :style="this.showSuccessModal ? 'display: block' : 'display: none'"
        :show="this.showSuccessModal"
        modal-class="withdrawal-funds-modal custom-modal-notification"
        @close="this.showSuccessModal = false"
    >
      <template #body>
        <div class="modal-content custom-modal-notification">
          <img src="/img/png/notification/create-review.png" class="custom-modal-notification__image"/>
          <div class="custom-modal-notification__message">{{getLocalization('Your withdrawal request created!')}} </div>
          <div class="withdrawal-funds-modal__view-info">
            <div class="--row">
              <div class="--label">{{ getLocalization('Details / wallet') }}</div>
              <div class="--dots"></div>
              <div class="--value">{{nameWithdrawal}}</div>
            </div>
            <div class="--row">
              <div class="--label">{{getLocalization('Amount to currency')}}</div>
              <div class="--dots"></div>
              <div class="--value">{{formData.sum}}</div>
            </div>
            <div class="--row">
              <div class="--label">{{getLocalization('Method')}}</div>
              <div class="--dots"></div>
              <div class="--value">{{formData.type_of_withdrawal.title}}</div>
            </div>
            <div class="--row">
              <div class="--label">{{ getLocalization('Details / wallet') }}</div>
              <div class="--dots"></div>
              <div class="--value">*{{formData.requisites.slice(-4)}}</div>
            </div>
          </div>
          <div class="custom-modal-notification__button withdrawal-funds-modal__submit">
            <button
                class="button orange"
                type="button"
                @click="showSuccessModal = false"
            >
              <img src="/img/svg/common/check-circle.svg"/>
              {{getLocalization('Okay')}}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <div class="withdrawal-funds__title">
      <img src="/img/svg/header-user-menu/dollor-coin.svg">
      <h1>{{ getLocalization('Withdrawal') }}</h1>
    </div>
    <div class="withdrawal-funds__balances">
      <div class="--title">{{getLocalization('Your balance')}}</div>
      <div class="--grid">
        <div v-for="(one, index) in availableBalances">
          <div class="--code">{{ availableCurrency[index]['name'] }}</div>
          <div class="--value">{{ one }}</div>
        </div>
      </div>
      <div class="--button">
        <button class="button orange" data-bs-target="#paymentsPayoutModal" @click="toggleShowModalAdd">
          {{ getLocalization('Order a payout') }}
        </button>
      </div>
    </div>

    <div class="withdrawal-funds__content">
      <div class="withdrawal-funds__filter">
        <div>
          <div class="--label">{{ getLocalization('Payment type') }}</div>
          <div>
            <multiselect
                v-model="paymentTypes"
                @input="getList"
                :options="this.availableMethodsForFilter"
                label="title"
                :multiple="true"
                :searchable="false"
                :group-select="true"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="this.getLocalization('Payment type')"
                track-by="id"
            ></multiselect>
          </div>
        </div>
        <div>
          <div class="--label">{{ getLocalization('Withdrawal status') }}</div>
          <div>
            <multiselect
                v-model="withdrawalStatuses"
                @input="getList"
                :options="this.withdrawalStatusesForFilter"
                label="title"
                :searchable="false"
                :close-on-select="true"
                :multiple="true"
                :group-select="true"
                :show-labels="false"
                :placeholder="this.getLocalization('Withdrawal status')"
                track-by="id"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="withdrawal-funds__table">
        <table>
          <thead>
          <tr>
            <td>{{ getLocalization('Method') }}</td>
            <td>{{ getLocalization('Requisites') }}</td>
            <td>{{ getLocalization('Amount') }}</td>
            <td>{{ getLocalization('Currency') }}</td>
            <td>{{ getLocalization('Date') }}</td>
            <td>{{ getLocalization('Status') }}</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in allList">
            <td>{{ row['withdrawal_type']['description'] }}</td>
            <td>{{ row['requisites'] }}</td>
            <td>{{ row['sum'] }}</td>
            <td>{{ row['rate']['currency'] }}</td>
            <td>{{ row['updated_at'] }}</td>
            <td v-if="row['status']['id'] === 2">
              <div class="d-flex gap-2 align-items-center">
                <img src="/img/svg/common/round-check.svg"/>
                {{ getLocalization('Successfully') }}
              </div>
            </td>
            <td v-else-if="row['status']['id'] === 3">
              <div class="d-flex gap-2 align-items-center">
                <img src="/img/svg/common/round-error.svg"/>
                {{getLocalization('Canceled')}}
              </div>
            </td>
            <td v-else>
              <div class="d-flex gap-2 align-items-center">
                {{ getLocalization(row['status']['description']) }}
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="withdrawal-funds__cards">
        <div class="withdrawal-funds-card" v-for="row in allList">
          <div class="--row">
            <div class="--label">{{ getLocalization('Date') }}</div>
            <div class="--value">{{ row['updated_at'] }}</div>
          </div>
          <div v-if="row['status']['id'] === 2" class="--row --flex-0">
            <div class="--value">
              <img src="/img/svg/common/round-check.svg" class="--icon">
              {{ getLocalization('Successfully') }}
            </div>
          </div>
          <div v-else-if="row['status']['id'] === 3" class="--row --flex-0">
            <div class="--value">
              <img src="/img/svg/common/round-error.svg" class="--icon">
              {{getLocalization('Canceled')}}
            </div>
          </div>
          <div v-else class="--row --flex-0">
            <div class="--value">
              {{getLocalization( row['status']['description'] )}}
            </div>
          </div>
          <div class="--divider"></div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Payment type') }}</div>
            <div class="--value">
              {{ row['withdrawal_type']['description'] }}
            </div>
          </div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Requisites') }}</div>
            <div class="--value">
              {{ row['requisites'] }}
            </div>
          </div>
          <div class="--divider"></div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Amount') }}</div>
            <div class="--value">
              {{ row['sum'] }}
            </div>
          </div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Currency') }}</div>
            <div class="--value">
              {{ row['rate']['currency'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../../../../components/table/modalNew.vue';
import BaseSendRequestMixin from "../../../../components/mixins/BaseSendRequestMixin.vue";
import BaseLoaderMixin from "../../../../components/mixins/BaseLoaderMixin.vue";
import BaseMessagingMixin from "../../../../components/mixins/BaseMessagingMixin.vue";
import BaseTable from "../../../../components/table/baseTable.vue";
import CustomPagination from "../../../../components/table/pagination/customPagination.vue";
import WithdrawalMixin from "../../../../components/mixins/WithdrawalMixin.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "dynamicTopUpStatistic",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin,
    BaseLoaderMixin,
    WithdrawalMixin
  ],
  components: {
    Modal,
    BaseTable,
    CustomPagination,
    Multiselect
  },
  props: [
    'userBalance',
    'availableCurrencies',
    'contactOptions',
    'availableMethodsForFilter',
    'withdrawalStatusesForFilter',
    'availableWithdrawalMethods',
    'rubCurrency',
    'routeWithdrawalRequest'
  ],
  data: function () {
    return {
      availableBalances: [],
      currencyTypes: [],
      paymentTypes: [],
      withdrawalStatuses: [],
      allList: [],
      showSuccessModal: false,
      nameWithdrawal: 'RUB',
      activeCurrencyFilter: null,
      usdRate: null
    }
  },
  mounted() {
    this.availableCurrencyAndRates();
    this.setTypeOfWithdraw(this.availableWithdrawalMethods[0]);
    this.getList();
    this.prepareUsdRate();
  },
  methods: {
    setAllBalance() {
      let currencyId = this.formData.currency_id
      const rate = this.availableCurrencies.find(obj => obj.id === currencyId).rate;
      let allAvailableSum = this.userBalance / rate
      this.formData.sum = Math.floor(allAvailableSum * 100) / 100;
    },
    availableCurrencyAndRates() {
      let availableCurrencies = Object.keys(this.availableCurrencies)
      for (let i = 0; i < availableCurrencies.length; i++) {
        let balanceOnRate = Math.floor((this.userBalance / Object.values(this.availableCurrencies)[i]['rate']) * 100) / 100 + ' ' + Object.values(this.availableCurrencies)[i]['symbol'];
        this.availableBalances.push(balanceOnRate)
        this.availableCurrency.push({
          id: Object.values(this.availableCurrencies)[i]['id'],
          symbol: Object.values(this.availableCurrencies)[i]['symbol'],
          name: Object.values(this.availableCurrencies)[i]['currency'],
          rate: Object.values(this.availableCurrencies)[i]['rate']
        })
      }
    },
    async getList() {
      await this.doWithStopRequest(async () => {
        let params = {
          paymentTypes: this.paymentTypes.map(el => el.id),
          withdrawalStatuses: this.withdrawalStatuses.map(el => el.id),
          currencyTypes: this.currencyTypes.map(el => el.id)
        };
        let response = await this.sendRequest(
            '/cabinet/partner/withdrawal/getList',
            'get',
            params);
        if (response) {
          this.allList = response;
        }
      });
    },
    async changeCurrencyType(currency) {
      this.currencyTypes = [];
      this.activeCurrencyFilter = currency.id;
      this.currencyTypes.push(currency);
      await this.getList();
    },
    prepareUsdRate() {
      this.usdRate = this.availableCurrency.find(el => el.name === 'USD')?.rate;
    }
  },
  watch: {
    selectedOption(newOption, oldOption) {
      if (newOption !== oldOption) {
        this.contactOptions.forEach(option => option.selected = (option.id === newOption.id));
      }
    },
    showSuccessModal(val) {
      if (val === true) {
        this.getList();
      }
    },
    'formData.currency_id'(val) {
      this.nameWithdrawal = this.availableCurrency[val]['name'];
    }
  }
}
</script>
